export default __webpack_public_path__ + "static/media/back.942004a7.svg";